import { ActionType } from 'typesafe-actions';
import * as actions from './actions';

export enum CommonContextActionTypes {
    REPLACE_CONTEXT = 'context/REPLACE_CONTEXT',
    WORKSPACE_ID_UPDATED = 'context/WORKSPACE_ID_UPDATED',
    SETUP_WORKSPACES = 'context/SETUP_WORKSPACES',
    LOAD_MISSING_PROPERTIES = 'context/LOAD_MISSING_PROPERTIES',
    REFRESH_MISSING_PROPERTIES = 'context/REFRESH_MISSING_PROPERTIES',
}

export type CommonContextAction = ActionType<typeof actions>;
